<template>
  <vs-popup
    class="add-lab-cost-popup"
    title="DRY SUNDRY COSTS"
    :active.sync="open"
    :buttons-hidden="true"
    @close="open = false"
  >
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card>
          <template #actions>
            <vs-button
              size="small"
              color="primary"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              @click="addNewRow"
            >
              Add New Tier
            </vs-button>
          </template>

          <ValidationObserver ref="form">
            <vs-table stripe class="mt-8" :data="list">
              <template slot="thead">
                <vs-th width="5%"></vs-th>
                <vs-th width="12%">MIN VALUE(KG)</vs-th>
                <vs-th width="12%">MAX VALUE(KG)</vs-th>
                <vs-th width="12%">PRICE(GBP)</vs-th>
              </template>

              <template slot-scope="{ data }">
                <draggable
                  v-model="list"
                  tag="tbody"
                  handle=".drag-handle"
                  animation="200"
                  @end="onDragEnd"
                >
                  <vs-tr
                    v-for="(item, index) in data"
                    :key="item.temp_id || item.id"
                  >
                    <vs-td width="5%">
                      <i class="feather icon-menu drag-handle cursor-move"></i>
                    </vs-td>

                    <vs-td>
                      <ValidationProvider
                        :vid="`min_value_${index}`"
                        :name="`Row ${index + 1} Min Value`"
                        :rules="{
                          required: true,
                          min_qty: item.max_value,
                          continuous_range: {
                            prevMax:
                              index > 0 ? list[index - 1].max_value : null,
                            rowIndex: index + 1,
                          },
                        }"
                        v-slot="{ errors }"
                      >
                        <vs-input
                          v-model="item.min_value"
                          size="small"
                          class="w-full"
                          :danger="!!errors[0]"
                          :danger-text="errors[0]"
                          val-icon-danger="icon-x"
                          val-icon-pack="feather"
                        />
                      </ValidationProvider>
                    </vs-td>

                    <vs-td>
                      <ValidationProvider
                        :vid="`max_value_${index}`"
                        :name="`Row ${index + 1} Max Value`"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <vs-input
                          v-model="item.max_value"
                          size="small"
                          class="w-full"
                          :danger="!!errors[0]"
                          :danger-text="errors[0]"
                          val-icon-danger="icon-x"
                          val-icon-pack="feather"
                        />
                      </ValidationProvider>
                    </vs-td>

                    <vs-td>
                      <ValidationProvider
                        :vid="`price_${index}`"
                        :name="`Row ${index + 1} Price`"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <vs-input
                          v-model="item.price"
                          size="small"
                          class="w-full"
                          :danger="!!errors[0]"
                          :danger-text="errors[0]"
                          val-icon-danger="icon-x"
                          val-icon-pack="feather"
                        />
                      </ValidationProvider>
                    </vs-td>
                  </vs-tr>
                </draggable>
              </template>
            </vs-table>

            <div class="flex justify-end mt-6">
              <vs-button
                color="success"
                type="filled"
                @click="saveAll"
              >
                Save
              </vs-button>
            </div>
          </ValidationObserver>
        </vx-card>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import draggable from "vuedraggable";
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import ErrorMessages from '@/mixins/ErrorMessages'

const SprayDryCostRepository = RepositoryFactory.get("spray_dry_cost");

export default {
  name: "SprayDrySundryCostsPopUp",

  components: { draggable },

  data() {
    return {
      id: "",
      open: false,
      list: [],
    };
  },

  mixins: [ErrorMessages],

  methods: {
    async openPopup(id = null) {
      if (id) {
        this.id = id;
        await this.getList();
      }
      this.open = true;
    },
    async getList() {
      const payload = (
        await SprayDryCostRepository.getSprayDrySundryCostsList(this.id)
      ).data;
      this.list = payload.data.sort((a, b) => a.order - b.order);
    },

    addNewRow() {
      this.list.push({
        temp_id: Date.now(),
        min_value: "",
        max_value: "",
        price: "",
        order: this.list.length + 1,
        is_new: true,
      });
    },

    async saveAll() {
      const isValid = await this.$refs.form.validate();
      if (!isValid || this.list.length === 0) return;

      try {
        this.$vs.loading()
        this.list = this.list.map((item, index) => ({
          ...item,
          order: index + 1,
        }));

        const formattedRanges = this.list.map((item) => {
          const range = {
            min_value: Number(item.min_value),
            max_value: Number(item.max_value),
            price: Number(item.price),
            order: item.order,
          };

          if (item.id) {
            range.id = item.id;
          }

          return range;
        });

        const payload = {
          currency_id: 1,
          ranges: formattedRanges,
        };

        await SprayDryCostRepository.createOrUpdateSprayDrySundryCosts(
          this.id,
          payload
        );
        await this.getList();

        this.$nextTick(() => {
          this.$refs.form.reset();
        });
        this.$vs.loading.close()
      } catch (error) {
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
    },

    async onDragEnd() {
      try {
        this.list = this.list.map((item, index) => ({
          ...item,
          order: index + 1,
        }));

        await this.$nextTick();
        await this.$refs.form.validate();
      } catch (error) {
        await this.getList();
      }
    },
  },
};
</script>
